import PropTypes from 'prop-types';
import { Row, Col, Typography } from 'antd';
import IntlMessages from "../../../components/utility/intlMessages";
import { mapHealthRecordNameToLocaleKey } from "../../../helpers/utility";

const { Title } = Typography;

function ClinicDetailsHealthRecords(props) {
  return (
    <Row style={{ marginTop: '25px' }} gutter={[16, 16]}>
      <Col span={24}>
        <Title level={4}>
          <IntlMessages id="general.healthRecords" />
        </Title>
      </Col>
      <Col span={24}>
        <Row gutter={[16, 10]}>
          {Object.entries(props.data).map(([hrCategory, numOfRecords]) => {
            const title = mapHealthRecordNameToLocaleKey(hrCategory);
            return (
              <Col span={24}>
                <IntlMessages id={title} />: {numOfRecords}
              </Col>
            )
          })}
        </Row>
      </Col>
    </Row>
  )
}
ClinicDetailsHealthRecords.propTypes = {
  data: PropTypes.object.isRequired,
};

ClinicDetailsHealthRecords.defaultProps = {
  data: {}
}

export default ClinicDetailsHealthRecords;